/* import __COLOCATED_TEMPLATE__ from './banner.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { getMandatoryTwoFactorSeverity } from '../../../../../utils/ember-multipass-mandatory-two-factor-util';
const MILLISECONDS_IN_DAY = 1000 * 3600 * 24;
let TwoFactorMandatoryPromoBannerComponent = (_dec = service('ember-multipassfe-client'), _class = class TwoFactorMandatoryPromoBannerComponent extends Component {
  /**
   * Computed logic for <market-banner /> "variant" attribute which dictates the background color of banner
   * @returns {string}
   */
  get bannerVariant() {
    const {
      enforcementStartTimestamp,
      promptStartTimestamp
    } = this.multipassfeClient.mandatoryTwoFactorDetails;
    return getMandatoryTwoFactorSeverity({
      enforcementStartTimestamp,
      promptStartTimestamp
    });
  }

  /**
   * Days left until Mandatory 2FA enforcement i18n key and arguments
   * @returns {string}
   */
  get daysLeftText() {
    if (this.multipassfeClient.mandatoryTwoFactorDetails.enforcementStartTimestamp === undefined) {
      return '';
    }
    let days = Math.floor((new Date(this.multipassfeClient.mandatoryTwoFactorDetails.enforcementStartTimestamp).getTime() - Date.now()) / MILLISECONDS_IN_DAY);
    days = Math.max(days, 0); // ensure if prompt is shown past enforcement date that negative days do not render
    return this.intl.t(`${this.args.tPrefix}two_factor.mandatory_promo.generic.banner_days_left`, {
      days
    });
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TwoFactorMandatoryPromoBannerComponent as default };